module.exports = __webpack_public_path__ + "static/IMG_1175-2e576dc22dc812d461127ab9ae53b3dd.jpg";